/** @jsxImportSource @emotion/react */
import colors from '@sportninja/common/constants/appColors'

interface QuestionTypeIconProps {
  size?: number
  color?: string
  className?: string
}

/**
 * CountryIcon component - Icon for country question type
 * @param size - Icon size in pixels (default: 24)
 * @param color - Icon color (default: colors.NEUTRAL_50)
 * @param className - Additional CSS class name
 */
const CountryIcon = ({
  size = 24,
  color = colors.NEUTRAL_50,
  className,
}: QuestionTypeIconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 25'
      fill='none'
      className={className}
    >
      <path
        d='M12 2.5C6.48 2.5 2 6.98 2 12.5C2 18.02 6.48 22.5 12 22.5C17.52 22.5 22 18.02 22 12.5C22 6.98 17.52 2.5 12 2.5ZM11 20.43C7.05 19.94 4 16.58 4 12.5C4 11.88 4.08 11.29 4.21 10.71L9 15.5V16.5C9 17.6 9.9 18.5 11 18.5V20.43ZM17.9 17.89C17.64 17.08 16.9 16.5 16 16.5H15V13.5C15 12.95 14.55 12.5 14 12.5H8V10.5H10C10.55 10.5 11 10.05 11 9.5V7.5H13C14.1 7.5 15 6.6 15 5.5V5.09C17.93 6.28 20 9.15 20 12.5C20 14.58 19.2 16.47 17.9 17.89Z'
        fill={color}
      />
    </svg>
  )
}

export default CountryIcon
